module.exports = __webpack_public_path__ + "static/media/campaign_banner_en.d90cca60.png";